import React from 'react';
import { cn } from '../../../lib/cn';
import { Switch } from '../atoms';

/**
 * SwitchRow, the 52px label row with a trailing switch.
 *
 * CSS selector: `mobile/molecules.css` `.ds-switch-row`, with
 * `.ds-switch-row__text`, `.ds-switch-row__label` and `.ds-switch-row__sub`.
 *
 * Doctrine: the whole row is the hit target, so the row itself carries
 * `role="switch"` and `aria-checked` and the nested `<Switch>` is
 * presentational. Rendering a real button inside would be invalid markup and
 * would give the user two overlapping targets for one decision. The on state
 * is accent, because a switch marks control state.
 */
export const SwitchRow = React.forwardRef(function SwitchRow(
  { className, label, sub, checked = false, onCheckedChange, type = 'button', onClick, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      role="switch"
      aria-checked={checked}
      onClick={(event) => {
        if (onClick) onClick(event);
        if (onCheckedChange) onCheckedChange(!checked);
      }}
      className={cn('ds-switch-row', className)}
      {...rest}
    >
      <span className="ds-switch-row__text">
        <span className="ds-switch-row__label">{label}</span>
        {sub ? <span className="ds-switch-row__sub">{sub}</span> : null}
      </span>
      <Switch presentational checked={checked} />
    </button>
  );
});

export default SwitchRow;
